import { render, staticRenderFns } from "./mdiEmailAlertOutline.vue?vue&type=template&id=b65a2e6a"
import script from "./mdiEmailAlertOutline.vue?vue&type=script&lang=js"
export * from "./mdiEmailAlertOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
